import LoaderWrapper from '@/components/ui/LoaderWrapper/LoaderWrapper.tsx';
import NotLoggedIn from '@/router/middleware/NotLoggedIn.tsx';
import IsLoggedIn from '@/router/middleware/IsLoggedIn.tsx';
import OnboardingFinished from '@/router/middleware/OnboardingFinished.tsx';
import OnboardingNotFinished from '@/router/middleware/OnboardingNotFinished.tsx';
import OnboardingTripReady from '@/router/middleware/OnboardingTripReady.tsx';
import DnaCreated from '@/router/middleware/DnaCreated.tsx';
import CanUpgrade from '@/router/middleware/CanUpgrade.tsx';
import HasNotSubscription from '@/router/middleware/HasNotSubscription.tsx';
import IsTrialOrNotActiveSubscription from '@/router/middleware/IsTrialOrNotActiveSubscription.tsx';

const middlewareConfig = {
  middlewaresMap: {
    notLoggedIn: <NotLoggedIn />,
    loggedIn: <IsLoggedIn />,
    onboardingFinished: <OnboardingFinished />,
    onboardingNotFinished: <OnboardingNotFinished />,
    onboardingTripReady: <OnboardingTripReady />,
    dnaCreated: <DnaCreated />,
    canUpgrade: <CanUpgrade />,
    isTrialOrNotActiveSubscription: <IsTrialOrNotActiveSubscription />,
    hasNotSubscription: <HasNotSubscription />,
  },
  loader: <LoaderWrapper isLoading className="h-screen" />,
} as const;

export type MiddlewareType = keyof (typeof middlewareConfig)['middlewaresMap'];

export default middlewareConfig;
